import { RPAD, generateRandomString } from 'util';
const validationList = {
    master: ["plant", "mbrNo", "projectNm", "processCd", "unitCd", "cycle"],
};


const validationSub = (masterData, temp) => {
    let rd = [];
    let cnt = 0;
    let chk;

    let idRef;
    let cnt2 = 0;

    const { master, sub } = masterData;
    const { projectNm, mbrNo, processCd } = master;
    const subdata = sub.slice(0, -1);
    const uniqueCodeRef = RPAD(projectNm, 6, "0") + RPAD(mbrNo, 4, "0");

    let max;

    if (master.sheetCode) {
        const sort = subdata.filter(a => a.uniqueCode).sort((a, b) => {
            const anum = a.uniqueCode.substring(10, 12);
            const bnum = b.uniqueCode.substring(10, 12);
            return parseInt(anum) - parseInt(bnum);
        });
        const last = sort[sort.length - 1]?.uniqueCode.substring(10, 12) || -1;
        max = parseInt(last) + 1;
        idRef = subdata.map((a) => a.uniqueCode);
    } else {
        idRef = [];
        max = 0;
    }

    subdata.forEach((row, i) => {
        if (row.code !== null) {
            cnt2 = 0;
            let idRefinner = [...idRef];
            let uniqueCode;

            if (master.sheetCode && row.uniqueCode) {
                uniqueCode = row.uniqueCode;
            } else {
                while (true) {
                    let id2 = uniqueCodeRef + (("0" + max).slice(-2)) + "A" + "S" + generateRandomString();
                    if (!idRefinner.find((f) => f === id2)) {
                        uniqueCode = id2;
                        idRef.push(id2);
                        break;
                    }
                    if (cnt2 > 30) {
                        break;
                    }
                    cnt2++;
                }
                max++;
            }

            /*            if (chk !== row.repeat) {
                            cnt++;
                            chk = row.repeat;
                        }*/

            rd.push({
                ...row,
                soCode: row.code,
                repeat: row.repeat,
                description: row.desc,
                inRemark: row.inRemark,
                outRemark: row.outRemark,
                qcRemark: row.qcRemark,
                revision: master.revision,
                sheetCode: master.sheetCode,
                soSeq: i + 1,
                seqCode: row.seqCode,
                uniqueCode: uniqueCode,
                interfaceCode:row.interfaceCode,
                soNm:row.label
            });
        }
    });
    /*    if (cnt > 3) {
            // throw new Error(t("invalidSave2"));
            throw new Error("invalidSave2");
        }*/
    if ((!!!rd || rd.length < 1) && !temp) {
        throw new Error("Step Operation 정보가 없습니다.");
    }
    return rd;
};

const validationData = (masterdata, type, temp) => {
    let rd = [];
    let tmparr;
    let tmp;
    let chkarr = [];

    const { master, sub, data } = masterdata;

    let idRef = [];

    if (master.sheetCode) {
        data.forEach((a) => {
            const b = a.map(m => {
                return m.filter(f => f.name === "uniqueCode" && f.value)[0]?.value

            })
            idRef = [...idRef, ...b.filter(f => f)];
        })
    } else {
        idRef = [];
    }

    data.forEach((d, i) => {


        let cnt2 = 0;


        tmparr = [];
        let uniqueCodeRef = sub[i].uniqueCode?.toString()?.substring(0, 13);

        d.forEach((dd, ii) => {
            let id;
            let idRefinner = [...idRef];

            /*            let hidechk = dd.filter((f) => f.name === "hide");
                        let hide = hidechk[0].value === "TRUE";*/
            let hide = "FALSE";
            tmp = {};
            let datachk = false;
            let valid = true;

            dd.forEach((ddd) => {
                if (ddd.name === "remark") {
                    tmp[ddd.name] = !!!ddd.value ? "FALSE" : ddd.value;
                } else if (ddd.name === "hide") {
                    tmp[ddd.name] = ddd.value;
                } else if (ddd.name === "uniqueCode") {
                    id = ddd.value;
                } else if (ddd.name === "optionCd") {
                    tmp["optionNm"] = ddd.label;
                    tmp[ddd.name] = ddd.value;
                } else {
                    //2026.02.03 luh Criticality 빈값일 때 필수값 체크하지 않던 현상 조치.
                    if (ddd.name === "rcvCritical") {
                        tmp["rcvCriticalNm"] = ddd.label;
                        tmp[ddd.name] = ddd.value;
                    }
                    if (!!ddd.value) {
                        datachk = true;
                    }
                    if (!!!ddd.value && ddd?.required) {
                        chkarr.push(ddd);
                        valid = false;
                    }
                    tmp[ddd.name] = ddd.value;
                }
            });

            if (!id || !master.sheetCode) {
                while (true) {
                    let id2 = uniqueCodeRef + type + generateRandomString();
                    if (!idRefinner.find((f) => f === id2)) {
                        id = id2;
                        idRef.push(id2);
                        break;
                    }
                    if (cnt2 > 30) {
                        break;
                    }
                    cnt2++;
                }
            }
            tmp["uniqueCode"] = id;
            tmp["hide"] = "FALSE";
            if (!datachk && !hide) {
                tmp["hide"] = "TRUE";
            }
            if (!valid && !temp && tmp["hide"] !== "TRUE") {
                // throw new Error(t("invalidSave3"));
                throw new Error("invalidSave3");
            }

            tmp = {
                ...tmp,
                revision: master.revision,
                soSeq: i + 1,
                paraSeq: ii + 1,
                sheetCode: master.sheetCode,
            };
            tmparr = [...tmparr, tmp];
        });
        rd = [...rd, [...tmparr]];
    });
    return rd;
};
const validationData2 = (masterdata, type, temp) => {
    let rd = [];
    let tmp;
    const { master, sub, data } = masterdata;

    let idRef;
    let cnt2 = 0;
    if (master.sheetCode) {
        idRef = data.map((a) => {
            const b = a.find((f) => f.name === "uniqueCode");
            if (b) {
                return b?.value;
            }
        });
    } else {
        idRef = [];
    }

    let uniqueCodeRef = sub[0]?.uniqueCode?.toString()?.substring(0, 13);

    data.forEach((d, i) => {
        let id;
        let idRefinner = [...idRef];
        tmp = {};
        let valid = true;
        d.forEach((dd) => {
            if (dd.name === "remark") {
                tmp[dd.name] = !!!dd.value ? "FALSE" : dd.value;
            } else if (dd.name === "uniqueCode") {
                id = dd.value;
            } else {
                if (!!!dd.value && !temp && dd?.required) {
                    valid = false;
                }
                tmp[dd.name] = dd.value;
            }
        });

        if (!id || !master.sheetCode) {
            while (true) {
                let id2 = uniqueCodeRef + type + generateRandomString();
                if (!idRefinner.find((f) => f === id2)) {
                    id = id2;
                    idRef.push(id2);
                    break;
                }
                if (cnt2 > 30) {
                    break;
                }
                cnt2++;
            }
        }
        tmp["uniqueCode"] = id;

        if (!valid && !temp) {
            // throw new Error(t("invalidSave2"))
        }
        tmp = {
            ...tmp,
            comSeq: i + 1,
            revision: master.revision,
            sheetCode: master.sheetCode,
        };
        rd = [...rd, tmp];
    });
    return rd;
};

const readyValidationData = (masterdata) => {
    const {data } = masterdata;
    let valid = true;

    data.forEach((d, i) => {
        d.forEach((dd, ii) => {
            dd.forEach((ddd) => {
                if (!!!ddd.value && ddd?.readyRequired) {
                    valid = false;
                }
            })

            if (!valid ) {
                // throw new Error(t("invalidSave3"));
                throw new Error("invalidReady");
            }
        })
    })


}

export { validationSub, validationData, validationData2,readyValidationData };
